import showNav from "assets/images/showNav.png"
/**
 * 门户文本默认配置数据
 */
export const home = [
  {
    fontWeight: 400,
    fontSize: 16,
    bgColorIsThemeColor: true,
    borderIsThemeColor: true,
    background: [
      {
        label: "颜色",
        isThemeColor: true,
        type: "color",
        color: "rgb(61, 130, 242)"
      }
    ],
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: {
      label: "颜色",
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(61,130,242,1)", 0],
          ["rgba(61,130,242,1)", 1]
        ]
      },
      color: "rgba(61,130,242,1)"
    },
    height: 36
  },
  {
    styleId: 2,
    background: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        data: {
          angle: 0,
          stops: [
            ["rgba(255,255,255,1)", 0],
            ["rgba(246,206,1,1)", 1]
          ]
        },
        color: "rgba(255,255,255,1)"
      }
    ],
    bgColorIsThemeColor: true,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    menuName: "按钮",
    borderWidth: [1, 1, 1, 1],
    width: 84,
    height: 32,
    iconPosition: "right",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 22,
    resInfo: {
      id: 2001,
      name: "右",
      content: "\n\n\n",
      createTime: "2022-08-16 14:21:26",
      encrypt: "33d71f5d48721111ed0b1a46651bc34ffba4",
      createUser: 0,
      type: 2,
      otherConfig: "",
      tags: "下一个,向右,箭头,方向"
    },
    iconMargin: 4,
    iconType: "icon",
    iconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(102,102,102,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ]
      },
      color: "rgba(102,102,102,1)"
    },
    borderIsThemeColor: false,
    iconWidth: 16,
    borderTypeFlag: 2,
    iconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    hoverIconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    clickIconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    borderColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(102,102,102,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ]
      },
      color: "rgba(102,102,102,1)"
    },
    colorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(102,102,102,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ]
      },
      color: "rgba(102,102,102,1)"
    },
    hoverAnimates: [
      {
        animateOnSelf: true, // 默认组件中的动画，默认动画是否只作用在组件自身
        ids: {},
        controlIds: {},
        animateType: "fontColor",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-color",
        passiveIds: [],
        animateClass: "cx_hover__fontColor",
        name: "文字颜色",
        animateLeaveClass: "",
        animateId: "e85b6c20-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverColor: "var_Color_page.themeColor"
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      },
      {
        animateOnSelf: true,
        border: {
          borderIsThemeColor: true,
          borderStyle: "solid",
          borderWidth: [1, 1, 1, 1],
          borderColor: {
            label: "颜色",
            type: "color",
            data: {
              angle: 0,
              stops: [
                ["rgba(0,0,0,1)", 0],
                ["rgba(0,0,0,1)", 1]
              ]
            },
            color: "rgba(0,0,0,1)"
          }
        },
        ids: {},
        controlIds: {},
        animateType: "border",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-border",
        passiveIds: [],
        animateClass: "cx_hover__border",
        name: "边框",
        animateLeaveClass: "",
        animateId: "ed53b340-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverBorderTopWidth: "1px",
          hoverBorderRightWidth: "1px",
          hoverBorderBottomWidth: "1px",
          hoverBorderLeftWidth: "1px",
          hoverBorderStyle: "solid",
          hoverBorderColor: "var_BorderColor_page.themeColor",
          hoverBorderWidth: 0
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      },
      {
        animateOnSelf: true,
        ids: {},
        controlIds: {},
        icon: {
          src: "33d71f5d48721111ed0b1a46651bc34ffba4",
          type: "icon",
          colorIsThemeColor: true,
          color: {
            label: "颜色",
            type: "color",
            data: {
              angle: 0,
              stops: [
                ["rgba(61,130,242,1)", 0],
                ["rgba(0,0,0,1)", 1]
              ]
            },
            color: "rgba(61,130,242,1)"
          }
        },
        animateType: "iconReplace",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-replace",
        passiveIds: [],
        animateClass: "cx_hover__icon_replace",
        name: "图标替换",
        animateLeaveClass: "cx_hover_leave__icon_replace",
        animateId: "fe2e1f70-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverIconColor: "rgba(61,130,242,1)",
          hoverIconSrcType: "options_iconSrcType_1"
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      }
    ]
  },
  {
    styleId: 3,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    menuName: "按钮",
    borderWidth: [0, 0, 0, 0],
    width: 44,
    height: 20,
    bgColorIsThemeColor: true,
    iconPosition: "right",
    textLimitLines: 8,
    fontWeight: 400,
    background: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        data: {
          angle: 0,
          stops: [
            ["rgba(255,255,255,0)", 0],
            ["rgba(246,206,1,1)", 1]
          ]
        },
        color: "rgba(255,255,255,0)"
      }
    ],
    lineHeight: 20,
    resInfo: {
      id: 2001,
      name: "右",
      content: "\n\n\n",
      createTime: "2022-08-16 14:21:26",
      encrypt: "33d71f5d48721111ed0b1a46651bc34ffba4",
      createUser: 0,
      type: 2,
      otherConfig: "",
      tags: "下一个,向右,箭头,方向"
    },
    iconMargin: 0,
    iconType: "icon",
    iconColor: {
      label: "颜色",
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(153,153,153,1)", 0],
          ["rgba(68,68,68,1)", 1]
        ]
      },
      color: "rgba(153,153,153,1)"
    },
    iconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    iconWidth: 16,
    borderTypeFlag: 2,
    hoverIconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    clickIconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    borderColor: {
      label: "颜色",
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(221,221,221,1)", 0],
          ["rgba(61,130,242,1)", 1]
        ]
      },
      color: "rgba(221,221,221,1)"
    },
    content: "按钮",
    hoverIconSrcType: 1,
    colorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(102,102,102,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ]
      },
      color: "rgba(102,102,102,1)"
    },
    hoverAnimates: [
      {
        animateOnSelf: true,
        ids: {},
        controlIds: {},
        animateType: "fontColor",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-color",
        passiveIds: [],
        animateClass: "cx_hover__fontColor",
        name: "文字颜色",
        animateLeaveClass: "",
        animateId: "961ae760-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverColor: "var_Color_page.themeColor"
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      },
      {
        animateOnSelf: true,
        ids: {},
        controlIds: {},
        icon: {
          src: "33d71f5d48721111ed0b1a46651bc34ffba4",
          type: "icon",
          colorIsThemeColor: true,
          color: {
            label: "颜色",
            type: "color",
            data: {
              angle: 0,
              stops: [
                ["rgba(61,130,242,1)", 0],
                ["rgba(0,0,0,1)", 1]
              ]
            },
            color: "rgba(61,130,242,1)"
          }
        },
        animateType: "iconReplace",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-replace",
        passiveIds: [],
        animateClass: "cx_hover__icon_replace",
        name: "图标替换",
        animateLeaveClass: "cx_hover_leave__icon_replace",
        animateId: "9d432de0-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverIconColor: "rgba(61,130,242,1)",
          hoverIconSrcType: "options_iconSrcType_1"
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      }
    ]
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [
  {},
  {
    styleId: 2,
    color: "rgb(23, 112, 255)",
    bgColor: "rgba(255,255,255,1)",
    hoverColor: "rgb(23, 112, 255)",
    hoverBackground: "rgba(255,255,255,1)",
    hoverBgColor: "rgba(255,255,255,1)"
  },
  {
    styleId: 3,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    hoverBackground: "rgba(255,255,255,1)",
    hoverBorderTopLeftRadius: 4,
    hoverBorderTopRightRadius: 4,
    hoverBorderBottomLeftRadius: 4,
    hoverBorderBottomRightRadius: 4
  },
  {
    styleId: 3,
    color: "rgb(23, 112, 255)",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    bgColor: "rgba(255,255,255,1)",
    hoverColor: "rgb(23, 112, 255)",
    hoverBackground: "rgba(255,255,255,1)",
    hoverBorderTopLeftRadius: 4,
    hoverBorderTopRightRadius: 4,
    hoverBorderBottomLeftRadius: 4,
    hoverBorderBottomRightRadius: 4,
    hoverBgColor: "rgba(255,255,255,1)"
  },
  {
    styleId: 4,
    background: "rgb(23, 112, 255)",
    borderTopLeftRadius: 100,
    borderTopRightRadius: 100,
    borderBottomLeftRadius: 100,
    borderBottomRightRadius: 100,
    hoverBorderTopLeftRadius: 100,
    hoverBorderTopRightRadius: 100,
    hoverBorderBottomLeftRadius: 100,
    hoverBorderBottomRightRadius: 100
  },
  {
    styleId: 5,
    color: "rgb(23, 112, 255)",
    background: "rgba(255,255,255,1)",
    borderTopLeftRadius: 100,
    borderTopRightRadius: 100,
    borderBottomLeftRadius: 100,
    borderBottomRightRadius: 100,
    bgColor: "rgba(255,255,255,1)",
    hoverColor: "rgb(23, 112, 255)",
    hoverBackground: "rgba(255,255,255,1)",
    hoverBorderTopLeftRadius: 100,
    hoverBorderTopRightRadius: 100,
    hoverBorderBottomLeftRadius: 100,
    hoverBorderBottomRightRadius: 100,
    hoverBgColor: "rgba(255,255,255,1)"
  },
  {
    styleId: 6,
    background: "rgba(255,255,255,1)",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    boxShadowV: 3,
    boxShadowBlur: 8,
    hoverBorderTopLeftRadius: 4,
    hoverBorderTopRightRadius: 4,
    hoverBorderBottomLeftRadius: 4,
    hoverBorderBottomRightRadius: 4,
    hoverBoxShadowV: 3,
    hoverBoxShadowBlur: 8
  },
  {
    styleId: 7,
    color: "rgba(0, 0, 0, 0.8)",
    background: "rgba(255,255,255,1)",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: "rgba(233,233,233,1)",
    bgColor: "rgba(255,255,255,1)",
    hoverColor: "rgba(0, 0, 0, 0.8)",
    hoverBackground: "rgba(255,255,255,1)",
    hoverBorderTopLeftRadius: 4,
    hoverBorderTopRightRadius: 4,
    hoverBorderBottomLeftRadius: 4,
    hoverBorderBottomRightRadius: 4,
    hoverBorderColor: "rgba(233,233,233,1)",
    hoverBgColor: "rgba(255,255,255,1)"
  }
]

/**
 * app按钮默认配置数据
 */
export const appHome = [
  {
    fontWeight: 400,
    fontSize: 16,
    width: 80,
    bgColorIsThemeColor: true,
    borderIsThemeColor: true,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4
  },
  {
    styleId: 2,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    menuName: "按钮",
    borderWidth: [1, 1, 1, 1],
    width: 84,
    height: 40,
    bgColorIsThemeColor: true,
    iconPosition: "right",
    fontSize: 14,
    fontWeight: 400,
    background: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        data: {
          angle: 0,
          stops: [
            ["rgba(255,255,255,1)", 0],
            ["rgba(246,206,1,1)", 1]
          ]
        },
        color: "rgba(255,255,255,1)"
      }
    ],
    lineHeight: 20,
    resInfo: {
      id: 2001,
      name: "右",
      content: "\n\n\n",
      createTime: "2022-08-16 14:21:26",
      encrypt: "611F4ADD5D8607EA",
      createUser: 0,
      type: 2,
      otherConfig: "",
      tags: "下一个,向右,箭头,方向"
    },
    iconMargin: 0,
    iconType: "icon",
    iconColor: {
      label: "颜色",
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(153,153,153,1)", 0],
          ["rgba(68,68,68,1)", 1]
        ]
      },
      color: "rgba(153,153,153,1)"
    },
    iconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    iconWidth: 16,
    borderTypeFlag: 2,
    hoverIconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    clickIconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    borderColor: {
      label: "颜色",
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(221,221,221,1)", 0],
          ["rgba(61,130,242,1)", 1]
        ]
      },
      color: "rgba(221,221,221,1)"
    },
    hoverIconSrcType: 1,
    iconSrcType: 0,
    colorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(102,102,102,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ]
      },
      color: "rgba(102,102,102,1)"
    },
    hoverAnimates: [
      {
        animateOnSelf: true,
        ids: {},
        controlIds: {},
        animateType: "fontColor",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-color",
        passiveIds: [],
        animateClass: "cx_hover__fontColor",
        name: "文字颜色",
        animateLeaveClass: "",
        animateId: "e85b6c20-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverColor: "var_Color_page.themeColor"
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      },
      {
        animateOnSelf: true,
        border: {
          borderIsThemeColor: true,
          borderStyle: "solid",
          borderWidth: [1, 1, 1, 1],
          borderColor: {
            label: "颜色",
            type: "color",
            data: {
              angle: 0,
              stops: [
                ["rgba(0,0,0,1)", 0],
                ["rgba(0,0,0,1)", 1]
              ]
            },
            color: "rgba(0,0,0,1)"
          }
        },
        ids: {},
        controlIds: {},
        animateType: "border",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-border",
        passiveIds: [],
        animateClass: "cx_hover__border",
        name: "边框",
        animateLeaveClass: "",
        animateId: "ed53b340-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverBorderTopWidth: "1px",
          hoverBorderRightWidth: "1px",
          hoverBorderBottomWidth: "1px",
          hoverBorderLeftWidth: "1px",
          hoverBorderStyle: "solid",
          hoverBorderColor: "var_BorderColor_page.themeColor",
          hoverBorderWidth: 0
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      },
      {
        animateOnSelf: true,
        ids: {},
        controlIds: {},
        icon: {
          src: "33d71f5d48721111ed0b1a46651bc34ffba4",
          type: "icon",
          colorIsThemeColor: true,
          color: {
            label: "颜色",
            type: "color",
            data: {
              angle: 0,
              stops: [
                ["rgba(61,130,242,1)", 0],
                ["rgba(0,0,0,1)", 1]
              ]
            },
            color: "rgba(61,130,242,1)"
          }
        },
        animateType: "iconReplace",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-replace",
        passiveIds: [],
        animateClass: "cx_hover__icon_replace",
        name: "图标替换",
        animateLeaveClass: "cx_hover_leave__icon_replace",
        animateId: "fe2e1f70-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverIconColor: "rgba(61,130,242,1)",
          hoverIconSrcType: "options_iconSrcType_1"
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      }
    ]
  },
  {
    styleId: 3,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    menuName: "按钮",
    borderWidth: [0, 0, 0, 0],
    width: 44,
    height: 20,
    bgColorIsThemeColor: true,
    iconPosition: "right",
    fontWeight: 400,
    background: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        data: {
          angle: 0,
          stops: [
            ["rgba(255,255,255,0)", 0],
            ["rgba(246,206,1,1)", 1]
          ]
        },
        color: "rgba(255,255,255,0)"
      }
    ],
    lineHeight: 20,
    resInfo: {
      id: 2001,
      name: "右",
      content: "\n\n\n",
      createTime: "2022-08-16 14:21:26",
      encrypt: "611F4ADD5D8607EA",
      createUser: 0,
      type: 2,
      otherConfig: "",
      tags: "下一个,向右,箭头,方向"
    },
    iconMargin: 0,
    iconType: "icon",
    iconColor: {
      label: "颜色",
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(153,153,153,1)", 0],
          ["rgba(68,68,68,1)", 1]
        ]
      },
      color: "rgba(153,153,153,1)"
    },
    iconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    iconWidth: 16,
    borderTypeFlag: 2,
    hoverIconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    clickIconSrc: "33d71f5d48721111ed0b1a46651bc34ffba4",
    borderColor: {
      label: "颜色",
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(221,221,221,1)", 0],
          ["rgba(61,130,242,1)", 1]
        ]
      },
      color: "rgba(221,221,221,1)"
    },
    hoverIconSrcType: 1,
    iconSrcType: 0,
    colorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(102,102,102,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ]
      },
      color: "rgba(102,102,102,1)"
    },
    hoverAnimates: [
      {
        animateOnSelf: true,
        ids: {},
        controlIds: {},
        animateType: "fontColor",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-color",
        passiveIds: [],
        animateClass: "cx_hover__fontColor",
        name: "文字颜色",
        animateLeaveClass: "",
        animateId: "961ae760-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverColor: "var_Color_page.themeColor"
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      },
      {
        animateOnSelf: true,
        ids: {},
        controlIds: {},
        icon: {
          src: "33d71f5d48721111ed0b1a46651bc34ffba4",
          type: "icon",
          colorIsThemeColor: true,
          color: {
            label: "颜色",
            type: "color",
            data: {
              angle: 0,
              stops: [
                ["rgba(61,130,242,1)", 0],
                ["rgba(0,0,0,1)", 1]
              ]
            },
            color: "rgba(61,130,242,1)"
          }
        },
        animateType: "iconReplace",
        animateDuration: 300,
        animateDelay: 0,
        iconClass: "icon-portal-replace",
        passiveIds: [],
        animateClass: "cx_hover__icon_replace",
        name: "图标替换",
        animateLeaveClass: "cx_hover_leave__icon_replace",
        animateId: "9d432de0-55f8-11ee-8149-13fcfc39ae38",
        variable: {
          hoverIconColor: "rgba(61,130,242,1)",
          hoverIconSrcType: "options_iconSrcType_1"
        },
        animationIterationCount: 2,
        triggerType: "hover",
        componentName: "按钮"
      }
    ]
  }
]
export const layout_title_drawer_button = [
  {
    fontWeight: 400,
    fontSize: 16,
    width: 35,
    height: 35,
    iconWidth: 30,
    iconSrc: showNav,
    iconMargin: 0,
    content: "",
    iconColorIsThemeColor: true,
    iconType: "icon",
    // iconSrc: "d9d913c2585cf111ed0adb682146718b2bc7",
    borderWidth: [0, 0, 0, 0],
    background: [
      {
        type: "color",
        label: "颜色",
        isThemeColor: false,
        color: "#00000000",
        data: {
          angle: 0,
          stops: [
            ["#00000000", 0],
            ["#f6ce01", 1]
          ]
        }
      }
    ]
  }
]

export const list_page_drawer_button = [
  {
    fontWeight: 400,
    fontSize: 16,
    width: 35,
    height: 35,
    iconWidth: 30,
    iconSrc: showNav,
    iconMargin: 0,
    content: "",
    iconColorIsThemeColor: true,
    iconType: "icon",
    borderWidth: [0, 0, 0, 0],
    background: [
      {
        type: "color",
        label: "颜色",
        isThemeColor: false,
        color: "#00000000",
        data: {
          angle: 0,
          stops: [
            ["#00000000", 0],
            ["#f6ce01", 1]
          ]
        }
      }
    ],
    name: "导航菜单按钮",
    pluginName: ["listPageNavMenuDrawerPlugin"]
  }
]

export const app_multiFilter_drawer_button = [
  {
    fontWeight: 400,
    fontSize: 16,
    width: 35,
    height: 35,
    iconWidth: 30,
    iconSrc: showNav,
    iconMargin: 0,
    content: "",
    iconColorIsThemeColor: true,
    iconType: "icon",
    borderWidth: [0, 0, 0, 0],
    background: [
      {
        type: "color",
        label: "颜色",
        isThemeColor: false,
        color: "#00000000",
        data: {
          angle: 0,
          stops: [
            ["#00000000", 0],
            ["#f6ce01", 1]
          ]
        }
      }
    ],
    name: "多级筛选按钮",
    pluginName: ["appMultiFilterDrawerPlugin"]
  }
]

// 微信小程序按钮
export const wxLink_button = [
  {
    isWxLink: true,
    fontWeight: 400,
    fontSize: 16,
    width: 80,
    bgColorIsThemeColor: true,
    borderIsThemeColor: true,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    pluginName: ["linkToWebChat"]
  }
]

// 抽屉按钮
export const drawer_button = [
  {
    content: "按钮",
    fontWeight: 400,
    fontSize: 16,
    width: 80,
    bgColorIsThemeColor: true,
    borderIsThemeColor: true,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    pluginName: ["drawerPlugin"]
  }
]

// 移动端抽屉按钮
export const app_drawer_button = [
  {
    content: "按钮",
    fontWeight: 400,
    fontSize: 16,
    width: 80,
    bgColorIsThemeColor: true,
    borderIsThemeColor: true,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    pluginName: ["drawerPlugin"]
  }
]

// 收藏按钮
export const collect_button = [
  {
    content: "收藏",
    contentActive: "已收藏",
    fontWeight: 400,
    fontSize: 14,
    width: 100,
    textIsThemeColor: true,
    colorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    bgColorIsThemeColor: false,
    bgColor: "#fff",
    borderIsThemeColor: true,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    showIcon: true,
    iconType: "icon",
    iconSrc: "33d4fc3238721111ed0b1a41c34cd92d01be",
    iconWidth: 16,
    iconMargin: 4,
    iconPosition: "left",
    iconColorIsThemeColor: true,
    iconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    pluginName: ["collectPlugin"],
    activeWidth: 100,
    activeHeight: 40,
    activeFontSize: 14,
    activeFontStyle: "normal",
    activeFontWeight: 400,
    activeLineHeight: 14,
    activeTextDecoration: "none",
    activeColor: "rgba(255,255,255,1)",
    activeTextIsThemeColor: true,
    activeBgColorIsThemeColor: false,
    activeBgColor: "rgba(255,255,255,1)",
    activeBackground: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        color: "rgba(255,255,255,1)"
      }
    ],
    activeColorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    activeFontFamily: "sans-serif",
    activeBorderTopLeftRadius: 20,
    activeBorderTopRightRadius: 20,
    activeBorderBottomLeftRadius: 20,
    activeBorderBottomRightRadius: 20,
    activeBorderStyle: "solid",
    activeBorderColor: "rgba(23, 112, 255, 1)",
    activeBorderTypeFlag: 2,
    activeShowBorder: true,
    activeBorderWidth: 1,
    activeBorderIsThemeColor: true,
    activeBoxShadowColor: [],
    activeBoxShadowH: [],
    activeBoxShadowV: [],
    activeBoxShadowBlur: [],
    activeBoxShadowSpread: [],
    activePaddingTypeFlag: 2,
    activePaddingTop: 0,
    activePaddingRight: 0,
    activePaddingLeft: 0,
    activePaddingBottom: 0,
    activePadding: 0,
    activeRotate: 0,
    activeImgSrc: "",
    activeClipSize: "cover",
    activeBgType: "自定义",
    activeRepeatType: "no-repeat",
    activeAlignType: "center center",
    activeTextAlign: "center",
    activeOpacity: 1,
    activeWritingMode: "horizontal-tb",
    activeLetterSpacing: 0,
    activeIconPosition: "left",
    activeShowIcon: true,
    clickIconSrc: "33d4fc3238721111ed0b1a41c34cd92d01be",
    activeIconType: "icon",
    activeIconWidth: 16,
    activeIconMargin: 4,
    activeIconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    activeIconColorIsThemeColor: true,
    activeContentHasLimit: true,
    activeTextLimitLines: 8,
    activeLineHeightType: "px",
    activeLetterSpacingType: "px",

    hoverIsSameActive: true,
    hoverWidth: 100,
    hoverHeight: 40,
    hoverFontSize: 14,
    hoverFontStyle: "normal",
    hoverFontWeight: 400,
    hoverLineHeight: 14,
    hoverTextDecoration: "none",
    hoverColor: "rgba(255,255,255,1)",
    hoverTextIsThemeColor: true,
    hoverBgColorIsThemeColor: false,
    hoverBgColor: "rgba(255,255,255,1)",
    hoverBackground: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        color: "rgba(255,255,255,1)"
      }
    ],
    hoverColorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    hoverFontFamily: "sans-serif",
    hoverBorderTopLeftRadius: 20,
    hoverBorderTopRightRadius: 20,
    hoverBorderBottomLeftRadius: 20,
    hoverBorderBottomRightRadius: 20,
    hoverBorderStyle: "solid",
    hoverBorderColor: "rgba(23, 112, 255, 1)",
    hoverBorderTypeFlag: 2,
    hoverShowBorder: true,
    hoverBorderWidth: 1,
    hoverBorderIsThemeColor: true,
    hoverBoxShadowColor: [],
    hoverBoxShadowH: [],
    hoverBoxShadowV: [],
    hoverBoxShadowBlur: [],
    hoverBoxShadowSpread: [],
    hoverPaddingTypeFlag: 2,
    hoverPaddingTop: 0,
    hoverPaddingRight: 0,
    hoverPaddingLeft: 0,
    hoverPaddingBottom: 0,
    hoverPadding: 0,
    hoverRotate: 0,
    hoverImgSrc: "",
    hoverClipSize: "cover",
    hoverBgType: "自定义",
    hoverRepeatType: "no-repeat",
    hoverAlignType: "center center",
    hoverTextAlign: "center",
    hoverOpacity: 1,
    hoverWritingMode: "horizontal-tb",
    hoverLetterSpacing: 0,
    hoverIconPosition: "left",
    hoverShowIcon: true,
    hoverIconSrc: "33d4fc3238721111ed0b1a41c34cd92d01be",
    hoverIconType: "icon",
    hoverIconWidth: 16,
    hoverIconMargin: 4,
    hoverIconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    hoverIconColorIsThemeColor: true,
    hoverContentHasLimit: true,
    hoverTextLimitLines: 8,
    hoverLineHeightType: "px",
    hoverLetterSpacingType: "px"
  }
]
// 点赞按钮
export const like_button = [
  {
    content: "点赞",
    contentActive: "已点赞",
    fontWeight: 400,
    fontSize: 14,
    width: 100,
    textIsThemeColor: true,
    colorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    bgColorIsThemeColor: false,
    bgColor: "#fff",
    borderIsThemeColor: true,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    showIcon: true,
    iconType: "icon",
    iconSrc: "33d28af928721111ed0b1a46170ac4ecf3cd",
    iconWidth: 16,
    iconMargin: 4,
    iconPosition: "left",
    iconColorIsThemeColor: true,
    iconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    pluginName: ["likePlugin"],
    activeWidth: 100,
    activeHeight: 40,
    activeFontSize: 14,
    activeFontStyle: "normal",
    activeFontWeight: 400,
    activeLineHeight: 14,
    activeTextDecoration: "none",
    activeColor: "rgba(255,255,255,1)",
    activeTextIsThemeColor: false,
    activeBgColorIsThemeColor: true,
    activeBgColor: "rgba(255,255,255,1)",
    activeBackground: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        color: "rgba(23, 112, 255, 1)"
      }
    ],
    activeColorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(255,255,255,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ]
      },
      color: "rgba(255,255,255,1)"
    },
    activeFontFamily: "sans-serif",
    activeBorderTopLeftRadius: 20,
    activeBorderTopRightRadius: 20,
    activeBorderBottomLeftRadius: 20,
    activeBorderBottomRightRadius: 20,
    activeBorderStyle: "solid",
    activeBorderColor: "rgba(23, 112, 255, 1)",
    activeBorderTypeFlag: 2,
    activeShowBorder: true,
    activeBorderWidth: 1,
    activeBorderIsThemeColor: true,
    activeBoxShadowColor: [],
    activeBoxShadowH: [],
    activeBoxShadowV: [],
    activeBoxShadowBlur: [],
    activeBoxShadowSpread: [],
    activePaddingTypeFlag: 2,
    activePaddingTop: 0,
    activePaddingRight: 0,
    activePaddingLeft: 0,
    activePaddingBottom: 0,
    activePadding: 0,
    activeRotate: 0,
    activeImgSrc: "",
    activeClipSize: "cover",
    activeBgType: "自定义",
    activeRepeatType: "no-repeat",
    activeAlignType: "center center",
    activeTextAlign: "center",
    activeOpacity: 1,
    activeWritingMode: "horizontal-tb",
    activeLetterSpacing: 0,
    activeIconPosition: "left",
    activeShowIcon: true,
    clickIconSrc: "33d28af928721111ed0b1a46170ac4ecf3cd",
    activeIconType: "icon",
    activeIconWidth: 16,
    activeIconMargin: 4,
    activeIconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(255,255,255,1)", 0],
          ["rgba(255,255,255,1)", 1]
        ]
      },
      color: "rgba(255,255,255,1)"
    },
    activeIconColorIsThemeColor: false,
    activeContentHasLimit: true,
    activeTextLimitLines: 8,
    activeLineHeightType: "px",
    activeLetterSpacingType: "px",

    hoverIsSameActive: true,
    hoverWidth: 100,
    hoverHeight: 40,
    hoverFontSize: 14,
    hoverFontStyle: "normal",
    hoverFontWeight: 400,
    hoverLineHeight: 14,
    hoverTextDecoration: "none",
    hoverColor: "rgba(255,255,255,1)",
    hoverTextIsThemeColor: true,
    hoverBgColorIsThemeColor: false,
    hoverBgColor: "rgba(255,255,255,1)",
    hoverBackground: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        color: "rgba(255,255,255,1)"
      }
    ],
    hoverColorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    hoverFontFamily: "sans-serif",
    hoverBorderTopLeftRadius: 20,
    hoverBorderTopRightRadius: 20,
    hoverBorderBottomLeftRadius: 20,
    hoverBorderBottomRightRadius: 20,
    hoverBorderStyle: "solid",
    hoverBorderColor: "rgba(23, 112, 255, 1)",
    hoverBorderTypeFlag: 2,
    hoverShowBorder: true,
    hoverBorderWidth: 1,
    hoverBorderIsThemeColor: true,
    hoverBoxShadowColor: [],
    hoverBoxShadowH: [],
    hoverBoxShadowV: [],
    hoverBoxShadowBlur: [],
    hoverBoxShadowSpread: [],
    hoverPaddingTypeFlag: 2,
    hoverPaddingTop: 0,
    hoverPaddingRight: 0,
    hoverPaddingLeft: 0,
    hoverPaddingBottom: 0,
    hoverPadding: 0,
    hoverRotate: 0,
    hoverImgSrc: "",
    hoverClipSize: "cover",
    hoverBgType: "自定义",
    hoverRepeatType: "no-repeat",
    hoverAlignType: "center center",
    hoverTextAlign: "center",
    hoverOpacity: 1,
    hoverWritingMode: "horizontal-tb",
    hoverLetterSpacing: 0,
    hoverIconPosition: "left",
    hoverShowIcon: true,
    hoverIconSrc: "33d28af928721111ed0b1a46170ac4ecf3cd",
    hoverIconType: "icon",
    hoverIconWidth: 16,
    hoverIconMargin: 4,
    hoverIconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(23, 112, 255, 1)", 0],
          ["rgba(23, 112, 255, 1)", 1]
        ]
      },
      color: "rgba(23, 112, 255, 1)"
    },
    hoverIconColorIsThemeColor: true,
    hoverContentHasLimit: true,
    hoverTextLimitLines: 8,
    hoverLineHeightType: "px",
    hoverLetterSpacingType: "px"
  }
]

// 弹出框按钮
export const popover_button = [
  {
    content: "按钮",
    fontWeight: 400,
    fontSize: 16,
    width: 80,
    bgColorIsThemeColor: true,
    borderIsThemeColor: true,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    pluginName: ["popoverPlugin"]
  }
]

// 移动端弹出框按钮
export const app_popover_button = [
  {
    content: "按钮",
    fontWeight: 400,
    fontSize: 16,
    width: 80,
    bgColorIsThemeColor: true,
    borderIsThemeColor: true,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    pluginName: ["popoverPlugin"]
  }
]
// ip按钮
export const ip_button = [
  {
    isSystemComponent: false,
    isIndependenceComponent: false,
    isDefaultComponent: false,
    // name:"IP",
    menuName: "IP",
    fontWeight: 400,
    fontSize: 16,
    width: 220,
    borderIsThemeColor: false,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    pluginName: ["getIpPlugin"],
    inPreContent: "校内:",
    outPreContent: "校外:",
    isShowPreContent: true,
    isShowIp: true,
    content: "127.0.0.1",
    preContentType: 0, // 0是校内，1是校外
    preContentMargin: 0,
    contentHasLimit: false,
    color: "rgba(0,0,0,1)",
    bgColorIsThemeColor: false,
    borderWidth: 0,
    textAlign: "left",
    hasTextAlign: true,
    background: [
      {
        type: "color",
        label: "颜色",
        isThemeColor: false,
        color: "rgba(255,255,255,0)",
        data: {
          angle: 0,
          stops: [
            ["rgba(255,255,255,0)", 0],
            ["rgba(246,206,1,0)", 1]
          ]
        }
      }
    ]
  }
]

// 弹出框关闭按钮
export const control_popover_button = [
  {
    content: "",
    fontWeight: 400,
    fontSize: 16,
    width: 16,
    height: 16,
    iconSrc: "341a90dc58721111ed0b1a44515d233ecc01",
    background: [
      {
        label: "颜色",
        isThemeColor: false,
        type: "color",
        color: "rgba(255, 255, 255, 0)"
      }
    ],
    iconMargin: 0,
    borderIsThemeColor: true,
    borderWidth: 0,
    isQuickSite: true,
    left: 100,
    leftType: "%",
    top: 0,
    topType: "%",
    offset: [6, 6, 0, 0],
    margin: [0, 0, 0, "-100%"],
    cursorType: "pointer",
    pluginName: ["controlPopoverPlugin"]
  }
]

// 返回 按钮
export const page_return_button = [
  {
    content: "返回上一级",
    fontWeight: 400,
    fontSize: 14,
    width: 100,
    textIsThemeColor: false,
    colorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(255, 255, 255, 1)", 0],
          ["rgba(255, 255, 255, 1)", 1]
        ]
      },
      color: "rgba(255, 255, 255, 1)"
    },
    bgColorIsThemeColor: true,
    bgColor: "#fff",
    borderIsThemeColor: true,
    borderColor: "#fff",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    showIcon: true,
    iconType: "icon",
    iconSrc: "33d45fdd58721111ed0b1a46e387a56e57ea",
    iconWidth: 16,
    iconMargin: 10,
    iconPosition: "left",
    iconColorIsThemeColor: false,
    iconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(255, 255, 255, 1)", 0],
          ["rgba(255, 255, 255, 1)", 1]
        ]
      },
      color: "rgba(255, 255, 255, 1)"
    },
    pluginName: ["returnPlugin"],
    boxShadowColor: ["rgba(0, 0, 0, 0.2)"],
    boxShadowH: [0],
    boxShadowV: [4],
    boxShadowBlur: [4],
    boxShadowSpread: [0],
  }
]
// 返回 按钮 -- 大屏
export const bigScreen_return_button = [
  {
    content: "返回上一级",
    fontWeight: 400,
    fontSize: 14,
    width: 100,
    textIsThemeColor: false,
    colorArr: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(255, 255, 255, 1)", 0],
          ["rgba(255, 255, 255, 1)", 1]
        ]
      },
      color: "rgba(255, 255, 255, 1)"
    },
    bgColorIsThemeColor: false,
    bgColor: "rgba(0, 0, 0, 0.8)",
    borderIsThemeColor: false,
    borderColor: "rgba(0, 0, 0, 0.8)",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    showIcon: true,
    iconType: "icon",
    iconSrc: "33d45fdd58721111ed0b1a46e387a56e57ea",
    iconWidth: 16,
    iconMargin: 4,
    iconPosition: "left",
    iconColorIsThemeColor: false,
    iconColor: {
      label: "颜色",
      isThemeColor: false,
      type: "color",
      data: {
        angle: 0,
        stops: [
          ["rgba(255, 255, 255, 1)", 0],
          ["rgba(255, 255, 255, 1)", 1]
        ]
      },
      color: "rgba(255, 255, 255, 1)"
    },
    pluginName: ["returnPlugin"],
    boxShadowColor: ["rgba(0, 0, 0, 0.2)"],
    boxShadowH: [0],
    boxShadowV: [4],
    boxShadowBlur: [4],
    boxShadowSpread: [0],
  }
]
